import React, { useState } from 'react';
import { Anchor, Box, Button, Heading, Layer, Text, Tip } from 'grommet';
import { Close } from 'grommet-icons';
import PropTypes from 'prop-types';

export const ViewClosedJobsButton = ({ closedJobs } = {}) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Tip content="view closed jobs">
                <Button
                    secondary
                    size="medium"
                    label=<span>
                        <Text size="medium">Closed Jobs</Text>
                    </span>
                    onClick={() => setShowModal(true)}
                />
            </Tip>
            {showModal && (
                <ViewClosedJobsModal
                    closedJobs={closedJobs}
                    setShowModal={setShowModal}
                />
            )}
        </>
    );
};

const ViewClosedJobsModal = ({ closedJobs, setShowModal }) => {
    return (
        <Layer
            onClickOutside={() => setShowModal(false)}
            onEsc={() => setShowModal(false)}
            position="center">
            <Box
                pad="medium"
                round="6px"
                border={{ color: 'enrich-green-light', size: '3px' }}
                gap="30px"
                width="large">
                <Box fill={'horizontal'} direction="row" justify="between">
                    <Box>
                        <Heading level="3" margin={{ vertical: 'none' }}>
                            Closed Jobs
                        </Heading>
                    </Box>
                    <Box
                        align="end"
                        round={true}
                        onClick={() => {
                            setShowModal(false);
                        }}
                        cursor="pointer">
                        <Close color="enrich-red" />
                    </Box>
                </Box>
                <Box fill="horizontal">
                    {closedJobs?.length > 0 ? (
                        <Box overflow={{ vertical: 'auto' }}>
                            {closedJobs.map((job) => (
                                <Anchor
                                    key={job.id}
                                    href={`/jobs/${job.id}`}
                                    label={job.attributes.title}
                                />
                            ))}
                        </Box>
                    ) : (
                        'No Job available'
                    )}
                </Box>
            </Box>
        </Layer>
    );
};

ViewClosedJobsButton.propTypes = {
    closedJobs: PropTypes.array,
};

ViewClosedJobsModal.propTypes = {
    closedJobs: PropTypes.array,
    setShowModal: PropTypes.func,
};
